import { render } from "./trueOrFalseQuestion.vue?vue&type=template&id=5d93d40f&scoped=true"
import script from "./trueOrFalseQuestion.vue?vue&type=script&lang=js"
export * from "./trueOrFalseQuestion.vue?vue&type=script&lang=js"

import "./trueOrFalseQuestion.vue?vue&type=style&index=0&id=5d93d40f&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d93d40f"]])

export default __exports__